import { useRef } from 'react';

import { useLegalClientSaveGlobalFinancialMonitoringPartTwo } from 'api/requests';
import { useServerErrorNotify } from 'hooks';
import { useTranslation } from 'libs/i18n';

import { CompanyGlobalFinancialMonitoringPartTwoFormType } from '../forms/companyGlobalFinancialMonitoringPartTwoForm';
import {
  getInitialData,
  getSubmitData,
} from '../helpers/companyGlobalFinancialMonitoringPartTwo';

import { useOnboardingContext } from './useOnboardingContext';

export const useCompanyGlobalFinancialMonitoringPartTwo = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();

  const { error, loading, saveFinancialMonitoring } =
    useLegalClientSaveGlobalFinancialMonitoringPartTwo();
  const { t } = useTranslation();

  const initialValues = useRef(
    getInitialData(t, data.legalClient!.financialMonitoring)
  ).current;

  const onSubmit = async (
    values: CompanyGlobalFinancialMonitoringPartTwoFormType
  ) => {
    if (values) {
      const submitData = getSubmitData(values);
      await saveFinancialMonitoring(data.legalClient!.id, submitData);
      goToNext();
    }
  };

  useServerErrorNotify(error);

  return {
    onSubmit,
    goToBack,
    submitLoading: loading,
    initialValues,
  };
};
